/**
 * Represents a base error class for IPFabric domain errors
 *
 * Example:
 *   - When encountering an error related to a client not being found, an instance
 *     of BaseError can be instantiated with the error code 'client_not_found'.
 *     The error code serves as an identifier for this specific error scenario
 */
export class BaseError extends Error {
  /**
   * @param code Code that represents the error
   * @param message Error message
   */
  constructor(
    public readonly code: string,
    message: string,
  ) {
    super(message);
  }
}
